import SMSSignInModal from 'components/GlobalModals/SMSSignInModal/SMSSignInModal';
import { withSMSSignInModalProps } from 'viewModel/globalModals/SMSSignInModal/withSMSSignInModalProps';

const ConnectedSMSSignInModal = withSMSSignInModalProps(SMSSignInModal);

export default ConnectedSMSSignInModal;
